import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Composite cell used in the menu items DataTable: thumbnail + name + 1-2 line
 * truncated description. Mirrors the leftmost column in the mockup.
 */
const MenuItemImageCell = ({ item, getImageUrl, name, description }) => {
  const imageSrc = item.image_url ? getImageUrl?.(item.image_url) : null;
  // Localized overrides fall back to the item's base fields.
  const displayName = name ?? item.name;
  const displayDescription = description ?? item.description;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 1.5,
          overflow: 'hidden',
          flexShrink: 0,
          backgroundColor: 'action.hover',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 22,
          color: 'text.secondary',
        }}
      >
        {imageSrc ? (
          <Box
            component="img"
            src={imageSrc}
            alt=""
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <span aria-hidden="true">🍽️</span>
        )}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 600,
            color: 'text.primary',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {displayName}
        </Typography>
        {displayDescription && (
          <Typography
            sx={{
              fontSize: 12,
              color: 'text.secondary',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              lineHeight: 1.4,
              mt: 0.25,
            }}
          >
            {displayDescription}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MenuItemImageCell;
